// extracted by mini-css-extract-plugin
export var deleteModal = "_rk-0";